/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UiTemplateItemDto } from './UiTemplateItemDto';
import {
    UiTemplateItemDtoFromJSON,
    UiTemplateItemDtoFromJSONTyped,
    UiTemplateItemDtoToJSON,
} from './UiTemplateItemDto';

/**
 * Returns a ui template search
 * @export
 * @interface UiTemplateSearchResponse
 */
export interface UiTemplateSearchResponse {
    /**
     * Search terms which produced results
     * @type {{ [key: string]: string; }}
     * @memberof UiTemplateSearchResponse
     */
    searchTerms?: { [key: string]: string; };
    /**
     * Paging page size
     * @type {number}
     * @memberof UiTemplateSearchResponse
     */
    pageSize?: number;
    /**
     * Paging start record
     * @type {number}
     * @memberof UiTemplateSearchResponse
     */
    start?: number;
    /**
     * Total number of patient profiles
     * @type {number}
     * @memberof UiTemplateSearchResponse
     */
    total?: number;
    /**
     * Ordered by
     * @type {string}
     * @memberof UiTemplateSearchResponse
     */
    orderTerm?: string;
    /**
     * Order direction
     * @type {string}
     * @memberof UiTemplateSearchResponse
     */
    orderDirection?: string;
    /**
     * List of templates items
     * @type {Array<UiTemplateItemDto>}
     * @memberof UiTemplateSearchResponse
     */
    templateList?: Array<UiTemplateItemDto>;
}

/**
 * Check if a given object implements the UiTemplateSearchResponse interface.
 */
export function instanceOfUiTemplateSearchResponse(value: object): value is UiTemplateSearchResponse {
    return true;
}

export function UiTemplateSearchResponseFromJSON(json: any): UiTemplateSearchResponse {
    return UiTemplateSearchResponseFromJSONTyped(json, false);
}

export function UiTemplateSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UiTemplateSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'start': json['start'] == null ? undefined : json['start'],
        'total': json['total'] == null ? undefined : json['total'],
        'orderTerm': json['orderTerm'] == null ? undefined : json['orderTerm'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
        'templateList': json['templateList'] == null ? undefined : ((json['templateList'] as Array<any>).map(UiTemplateItemDtoFromJSON)),
    };
}

export function UiTemplateSearchResponseToJSON(value?: UiTemplateSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchTerms': value['searchTerms'],
        'pageSize': value['pageSize'],
        'start': value['start'],
        'total': value['total'],
        'orderTerm': value['orderTerm'],
        'orderDirection': value['orderDirection'],
        'templateList': value['templateList'] == null ? undefined : ((value['templateList'] as Array<any>).map(UiTemplateItemDtoToJSON)),
    };
}

